const Links = {
    appCandIos: 'https://apps.apple.com/us/app/tonalida-app/id6744417198',
    appEntIos: '',

    appCandPlay: "https://play.google.com/store/apps/details?id=tonalida.com.br.flutter_tonalida_candidates_app",
    appEntPlay: "https://play.google.com/store/apps/details?id=tonalida.com.br.flutter_tonalida_enterprise_app&pcampaignid=web_share",

    site: "https://tonalida.com.br",
    portal: 'https://portal.tonalida.com.br',

    whatsapp: "https://wa.me/5546984004056",
    whatsappGrupo: 'https://chat.whatsapp.com/ELounzPAZ7l6KO5taDTPAU?mode=ems_copy_t',

    instagram: 'https://www.instagram.com/tonalida_app?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
    facebook: 'https://www.facebook.com/tonalida?locale=pt_BR',
    linkding: 'https://www.linkedin.com/company/tonalida/?viewAsMember=true',
    x: 'https://x.com/TonalidaAPP',
    youtube: 'https://www.youtube.com/@tonalida_app',
    tiktok: 'https://www.tiktok.com/@tonalida_app',
    threds: 'https://www.threads.com/@tonalida_app',

    APIn8n: 'https://automations.tonalida.com.br/webhook/d522d81d-2c72-4efd-8623-4118b15e7542',
}

export default Links;